import {
  brandHealthFormat,
  percentageFormat,
  reviewsFormat,
  scoreFormat,
  sentimentFormat,
} from '@op/utils/value';
import {
  brandHealthRenderHelper,
  googleTrendsRenderHelper,
  sentimentNumber,
  zeroShowDefaultValue,
} from './value';
import { toPercentNumber } from '@op/components/DownloadCommon/download-page/render-helper';

export const commonRenderHelperMap: {
  [key: string]: {
    renderHelper?: Array<any>;
    numFmt?: Array<string | number> | string;
    format?: (value: number) => number | string;
  };
} = {
  brand_health: {
    renderHelper: [brandHealthRenderHelper],
    format: (value: number) =>
      value === -99999 ? '-' : brandHealthFormat(value),
  },
  sentiment: {
    renderHelper: [sentimentNumber],
    format: (value: number) => Number(sentimentFormat(value)),
    numFmt: '0.00',
  },
  non_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  steam_recent_reviews: {
    renderHelper: [zeroShowDefaultValue],
  },
  steam_all_reviews: {
    renderHelper: [zeroShowDefaultValue],
  },
  steam_all_reviews_positive: {
    numFmt: '0%',
    renderHelper: [zeroShowDefaultValue],
  },
  steam_recent_reviews_positive: {
    numFmt: '0%',
    renderHelper: [zeroShowDefaultValue],
  },
  steam_added_positive: {
    numFmt: '0.00%',
  },
  opencritic_recommended: {
    renderHelper: [
      (item: any, key: string) => {
        let value = item[key];
        return value ? value / 100 : 0;
      },
    ],
    numFmt: '0%',
    format: (value: number) => percentageFormat(value, '-', 0),
  },
  avg_ccv: {
    numFmt: '0.00',
    format: (value: number) => Number(reviewsFormat(value, 2)),
  },
  airtime: {
    numFmt: '0.00',
    format: (value: number) => Number(reviewsFormat(value, 2)),
  },
  google_trends: {
    renderHelper: [googleTrendsRenderHelper],
    format: (value: number) => scoreFormat(value, 0, 0),
  },
  xbox_lifetime_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  xbox_lifetime_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  xbox_filtered_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  xbox_filtered_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  playstation_lifetime_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  playstation_lifetime_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  google_play_lifetime_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  google_play_lifetime_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  google_play_filtered_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  google_play_filtered_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  app_store_lifetime_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  app_store_lifetime_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  app_store_filtered_rating: {
    numFmt: '0.0',
    format: (value: number) => Number(reviewsFormat(value, 1)),
  },
  app_store_filtered_negative: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  steam_positive_rate: {
    numFmt: '0.00%',
    format: (value: number) => percentageFormat(value * 100, '-', 2),
  },
  select_recommend_score: {
    numFmt: '0.00%',
    renderHelper: [toPercentNumber()],
  },
};
